import React, { useState } from "react";
import { Button, Form, Input, Grid, message, notification } from 'antd';
import { withApollo } from "@apollo/client/react/hoc";
import Auth from '@aws-amplify/auth';
import { useNavigate } from "react-router-dom";

const { useBreakpoint } = Grid;

const Login = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const screens = useBreakpoint();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const user = await Auth.signIn(values.username, values.password);
      localStorage.setItem('siteId', user.attributes['custom:siteId']);
      navigate("/Home", { state: { from: "Home Page" } });
    } catch (error) {
      message.error("Invalid username or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  // Show support notification
 const showSupportNotification = () => {
  notification.info({
    message: 'Technical Support',
    description: (
      <>
        For technical support, call us at:<br />
        <strong>+91 92092 98516</strong>
      </>
    ),
    placement: 'bottomRight',
  });
};

  return (
    <>
      <div style={{ backgroundColor: '#f0e8ff', minHeight: '100vh' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div
            style={{
              width: screens.xs ? '100%' : 1000,
              borderRadius: 8,
              display: 'flex',
              flexDirection: screens.xs ? 'column' : 'row',
              overflow: 'hidden'
            }}
          >
            {/* Left Section */}
            <div style={{
              flex: 1,
              position: 'relative',
              padding: 20,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <img
                src="SKINOLA 2025 1.png"
                alt="Doctor"
                style={{ maxHeight: 400, objectFit: 'contain' }}
              />
              <div style={{
                backgroundColor: '#4b2aad',
                color: 'white',
                padding: '20px',
                marginTop: -7,
                borderRadius: 4,
                maxWidth: 600,
                textAlign: 'left'
              }}>
                <h4 style={{ marginBottom: 8, 
                }}>
                  Welcome to <span style={{ color: '#ffffff' }}>Skinola International Aesthetics Management System</span>
                </h4>
                <p style={{ fontSize: 12 }}>
                  A cloud-based, streamlined conference event management system with a centralized, user-friendly interface.
                </p>
              </div>
            </div>

            {/* Right Section */}
            <div style={{ flex: 1, padding: '40px 30px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <img src="skinola (160 x 60 px) (1).png" alt="Logo" style={{ width: "200px" }} />
              <h2 style={{ fontWeight: 'bold', fontSize: 18, marginTop: 20 }}>Login</h2>
              <p style={{ fontSize: 13, marginBottom: 30 }}>Enter your credential to login to your account</p>

              <Form
                name="login"
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  label="Email"
                  name="username"
                  rules={[{ required: true, message: 'Please input your username!' }]}
                >
                  <Input size="large" />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password size="large" />
                </Form.Item>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
                  <span></span>
                  <span
                    style={{ fontSize: 14, cursor: 'pointer' }}
                    onClick={showSupportNotification}
                  >
                    Forgot Password ?
                  </span>
                </div>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    block
                    style={{ backgroundColor: '#4b2aad', borderColor: '#4b2aad' }}
                  >
                    Sign in
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>

        <h2 style={{ fontSize: 16, textAlign: 'center', marginTop: 10, color: '#333' }}>
          Designed and Developed by <a
            href="https://deinertech.com"
            style={{ textDecoration: "none" , color:"black" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Deinertech Software
          </a> | © Skinola International Aesthetics. All rights reserved.
        </h2>
      </div>
    </>
  );
};

export default withApollo(Login);
